// extracted by mini-css-extract-plugin
export var container = "_hz-1";
export var editor = "_hz-2";
export var resizable = "_hz-3";
export var wrapper = "_hz-0";